export default __webpack_public_path__ + "static/media/element_94.fdf4c8e5.jpg";